<div class="tabs-container flex flex-col">
  <div class='tabs-list-container'>
    <ul class="nav nav-tabs">
      <li
        *ngFor="let tab of tabs"
        [has-setting]="tab.requiredSetting"
        [has-privilege]="tab.requiredPrivilege"
        [hidden]="tab.hidden"
        class="tab"
        [ngClass]="{ active: tab.active, disabled: tab.disabled }"
        [ngStyle]="{ 'font-size': fontSize }"
        (click)="selectTab(tab)">
        <div class='flex items-center'>
          <mat-icon *ngIf='tab.icon' class='material-symbols-rounded'>{{ tab.icon }}</mat-icon>
          {{ tab.tabTitle }} {{ tab.subTitle }}
        </div>
      </li>
    </ul>
  </div>
  <ng-content></ng-content>
</div>
